import React from "react";

import { observer, inject } from "mobx-react";

import { createPassportModalState } from "../ui/passportModalState";

import Icon from "sulu-admin-bundle/components/Icon";
import Table from "sulu-admin-bundle/components/Table";

import FooterRow from "../../CustomList/FooterRow";
import TeamPlayerRow from "./rows/TeamPlayerRow";
import Modal from "../../../components/CustomList/PassportModal";

const { Header, Body, HeaderCell } = Table;

const localState = createPassportModalState();

const TeamListTable = inject("selectionStore")(
    observer(({ selectionStore, openModal, props }) => {
        const isCore = props.schemaOptions?.mode?.value === "core_squad";
        const filteredPlayers = Object.values(selectionStore.allPlayers).filter(
            (p) => {
                return (
                    !p.isDeleted &&
                    p.team === selectionStore.teamId &&
                    p.core === isCore
                );
            },
        );

        const closeHandler = () => {
            localState.close();
        };

        return (
            <>
                <Table>
                    <Header>
                        <HeaderCell>
                            {!props.disabled && (
                                <Icon name="su-plus" onClick={openModal} />
                            )}
                        </HeaderCell>
                        <HeaderCell>Trikot</HeaderCell>
                        <HeaderCell>Pass. nr.</HeaderCell>
                        <HeaderCell>Name, Vorname</HeaderCell>
                        <HeaderCell>Status</HeaderCell>
                        <HeaderCell>Captain</HeaderCell>
                        <HeaderCell>Positions</HeaderCell>
                        <HeaderCell>
                            <Icon name="su-trash-alt" />
                        </HeaderCell>
                    </Header>

                    <Body>
                        {filteredPlayers.map((player, index) => {
                            return (
                                <TeamPlayerRow
                                    key={player.id}
                                    player={player}
                                    index={index}
                                    localState={localState}
                                    disabled={props.disabled}
                                />
                            );
                        })}
                    </Body>
                </Table>

                <Modal
                    closeHandler={closeHandler}
                    isOpen={localState.openModal}
                    passportItem={localState.passportInfo}
                    loading={localState.passportLoading}
                />

                {isCore && (
                    <FooterRow
                        noOfSelectedPlayer={filteredPlayers.length}
                        minPlayers={
                            props.data.minNominatedSquadPlayerNo ||
                            props.data.minNominatedCoreSquadPlayers
                        }
                        maxPlayers={props.data.maxNominatedSquadPlayerNo}
                    />
                )}
            </>
        );
    }),
);

export default TeamListTable;
